import { useState, useCallback } from "react";
import localStorage from "store2";

const STORE_ID_KEY = "storeId";

export const useStoreId = () => {
	const [storeId, setStoreIdState] = useState<string | null>(
		() => localStorage.get(STORE_ID_KEY),
	);

	const saveStoreId = useCallback((id: string) => {
		localStorage.set(STORE_ID_KEY, id, true);
		setStoreIdState(id);
	}, []);

	return { storeId, saveStoreId };
};
